module.exports = __webpack_public_path__ + "img/kefu_right.0a1a09e3.png";